/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Po_Issue_Changes_PendingInputs */

const en_po_issue_changes_pending = /** @type {(inputs: Po_Issue_Changes_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`some still wait for a decision`)
};

/**
* | output |
* | --- |
* | "some still wait for a decision" |
*
* @param {Po_Issue_Changes_PendingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const po_issue_changes_pending = /** @type {((inputs?: Po_Issue_Changes_PendingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Po_Issue_Changes_PendingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_po_issue_changes_pending(inputs)
});